export enum SettingMenu {
  EntitySetup = 'Entity Setup',
  Security = 'Security',
  Language = 'Language',
  PermissionsRoles = 'Permission & Roles',
}

export enum DashboardMenu {
  All = 'All',
  BkBank = 'BK Bank',
  BkInsurance = 'BK Insurance',
  BkCapital = 'BK Capital',
  BkTechouse = 'BK Techouse',
  BkFoundation = 'BK Foundation',
}

export enum SubmitDataMenu {
  FocusArea = 'Focus Area',
  Objectives = 'Objectives',
  KPI = 'KPI',
  Initiatives = 'Initiatives',
  ActionPlan = 'Action Plan',
  CENDData = 'CEND Data',
  Users = 'Users',
  Reports = 'Reports',
}
